import React from 'react';
import clsx from 'clsx';
import {
	FontAwesomeIcon,
	type FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import {composeClasses} from '@netx/core-theme/utils/composeClasses';
import {styled} from '@netx/core-theme/styled';
import type {WithClasses, WithOwnerState} from '@netx/core-theme/types';
import {
	getIconUtilityClass,
	ICON_CLASS_NAME,
	type IconClasses,
	iconClasses,
} from './iconClasses';

type IconOwnerState = WithClasses<IconClasses, {}>;

const useUtilityClasses = (state: IconOwnerState) => {
	const {classes} = state;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getIconUtilityClass, classes);
};

const IconRoot = styled(FontAwesomeIcon, {
	name: ICON_CLASS_NAME,
	slot: 'Root',
})(({theme, ownerState}: WithOwnerState<IconOwnerState>) => ({
	overflow: 'visible !important',
}));

export interface IconProps extends WithClasses<
	IconClasses,
	FontAwesomeIconProps
> {}

export const IconPrimitive = (
	{classes: _classes, className, ...props}: IconProps,
	ref: React.ForwardedRef<SVGSVGElement>,
) => {
	const ownerState: IconOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<IconRoot
			className={clsx(classes.root, className)}
			ref={ref}
			{...props}
			ownerState={ownerState}
		/>
	);
};

export const Icon = React.forwardRef(IconPrimitive);

export default Icon;
